import { ProductAddonUpdatePage } from '@/features/product-addon/pages/ProductAddonUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-addon/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_addon.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductAddonUpdatePage,
})
